import { useEffect, useState } from "react";
import "../../paginas/Reportes/reportes.css";
import Calendario from "../../ComponentesGlobales/Calendario.jsx";
import { useStoreReportes } from "../../paginas/Reportes/useStoreReportes.js";
import { Chart } from 'primereact/chart';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useStoreHome } from "../../paginas/Home/useStoreHome.js";
import { enumReporteSeleccionado } from "../FuncionesLocales.js";
import ExportarReporte from "../ExportarReporte/ExportarReporte.jsx";
import { formatearFechaExportacion } from "../../servicios/reportesExportacion.js";



const DespachoReportes = () => {

  const FechaDesde = useStoreReportes((state) => state.FechaDesde);
  const FechaHasta = useStoreReportes((state) => state.FechaHasta);
  const ListaPorMercaderia = useStoreReportes((state) => state.ListaPorMercaderia);
  const BuscandoStock = useStoreReportes((state) => state.BuscandoStock);
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [chartsByUnit, setChartsByUnit] = useState({});
  const [clientePieChartsByUnit, setClientePieChartsByUnit] = useState({});



  useEffect(() => {
    useStoreHome.setState({ ReportesSeleccionado: enumReporteSeleccionado.DESPACHO });
    useStoreReportes.getState().getDespachado();
  }, [FechaDesde, FechaHasta]);



  // useEffect para agrupar por UnidadDescripcion
  useEffect(() => {
    if (ListaPorMercaderia && ListaPorMercaderia.length > 0) {
      const groupedByUnit = ListaPorMercaderia.reduce((acc, item) => {
        const unidad = item.UnidadDescripcion || 'Sin unidad';
        if (!acc[unidad]) {
          acc[unidad] = [];
        }
        acc[unidad].push(item);
        return acc;
      }, {});


      // Crear gráficos para cada unidad
      const chartsByUnitData = {};



      const colors = [
        "#FFF600",

        "#FBD23A",

        "#FEBF10",

        "#FFA807FF",

        "#FF9A00",

        "#FF7E00",

        "#FF5F00",
      ];



      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = "black";
      const textColorSecondary = "black";
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      Object.keys(groupedByUnit).forEach((unidad, index) => {
        const unitData = groupedByUnit[unidad];
        const labels = unitData.map(item => item.MercaderiaDescricpion || 'Sin descripción');
        const stockData = unitData.map(item => item.Unidades);
        const pesoData = unitData.map(item => item.Peso);

        // Datos para el gráfico de torta de esta unidad

        chartsByUnitData[unidad] = {
          data: {
            labels: labels,
            datasets: [
              //   {
              //   label: 'Cantidad en Stock',
              //   backgroundColor: colors[0],
              //   borderColor: colors[0],
              //   data: stockData
              // },
              {
                label: unidad,
                backgroundColor: colors,
                borderColor: colors,
                data: pesoData
              }]
          },
          options: {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
              legend: {
                labels: {
                  fontColor: textColor
                }
              },
              title: {
                display: true,
                text: `Despachos - ${unidad}`,
                color: textColor,
                font: {
                  size: 20,
                  weight: 'bold'
                }
              }
            },
            scales: {
              x: {
                ticks: {
                  color: textColorSecondary,
                  font: {
                    weight: 500
                  },
                  maxRotation: 90,
                  minRotation: 0
                },
                grid: {
                  display: true,
                  drawBorder: true
                }
              },
              y: {
                ticks: { color: textColorSecondary },
                grid: { color: surfaceBorder, drawBorder: false }
              }
            }
          }
        };
      });

      setChartsByUnit(chartsByUnitData);
    } else {
      setChartsByUnit({});
    }

  }, [ListaPorMercaderia]);

  // useEffect para crear gráficos de torta 
  useEffect(() => {
    if (ListaPorMercaderia && ListaPorMercaderia.length > 0) {
      // Agrupar datos por UnidadDescripcion
      const groupedByUnit = ListaPorMercaderia.reduce((acc, item) => {
        const unidad = item.UnidadDescripcion || 'Sin unidad';
        if (!acc[unidad]) {
          acc[unidad] = [];
        }
        acc[unidad].push(item);
        return acc;
      }, {});

      const pieChartsByUnitData = {};


      const colors = [
        "#FFF600",

        "#FBD23A",

        "#FEBF10",

        "#FFA807FF",

        "#FF9A00",

        "#FF7E00",

        "#FF5F00",
      ];




      Object.keys(groupedByUnit).forEach((unidad) => {
        const unitData = groupedByUnit[unidad];

        // Agrupar por ClienteDescripcion dentro de esta unidad
        const clienteGroups = unitData.reduce((acc, item) => {
          const cliente = item.ClienteDescripcion || 'Sin cliente';
          if (!acc[cliente]) {
            acc[cliente] = {
              cliente: cliente,
              totalPeso: 0,
              totalUnidades: 0
            };
          }
          acc[cliente].totalPeso += Number(item.Peso || 0);
          acc[cliente].totalUnidades += Number(item.Unidades || 0);
          return acc;
        }, {});

        const clienteData = Object.values(clienteGroups);

        // Crear datos para el gráfico de torta por peso
        const pieDataPeso = {
          labels: clienteData.map(item => item.cliente),
          datasets: [{
            data: clienteData.map(item => item.totalPeso),
            backgroundColor: colors.slice(0, clienteData.length),
            borderWidth: 1
          }]
        };

        // Crear datos para el gráfico de torta por unidades
        const pieDataUnidades = {
          labels: clienteData.map(item => item.cliente),
          datasets: [{
            data: clienteData.map(item => item.totalUnidades),
            backgroundColor: colors.slice(0, clienteData.length),
            borderWidth: 1
          }]
        };

        const pieOptions = {
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                color: 'black',
                usePointStyle: true,
                padding: 15,
                font: {
                  size: 11
                }
              }
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  const total = context.dataset.data.reduce((acc, curr) => acc + curr, 0);
                  const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                  return `${label}: ${value.toFixed(2)} (${percentage}%)`;
                }
              }
            }
          },
          maintainAspectRatio: false
        };

        pieChartsByUnitData[unidad] = {
          peso: { data: pieDataPeso, options: pieOptions },
          unidades: { data: pieDataUnidades, options: pieOptions }
        };
      });

      setClientePieChartsByUnit(pieChartsByUnitData);
    } else {
      setClientePieChartsByUnit({});
    }
  }, [ListaPorMercaderia]);


  //console.log(ListaPorMercaderia)


  return (
    <div>
      <h2 className="titulo-p">Despacho</h2>
      <div className="reportes-exportacion">
        <ExportarReporte endpoint="PISeunReportes/ListaDespachado" nombre="Despachos" filters={{ FechaDesde: formatearFechaExportacion(FechaDesde), FechaHasta: formatearFechaExportacion(FechaHasta), Lote: "" }} disabled={BuscandoStock} />
      </div>
      <div className="filtros-fecha" >
        <div>
          <span style={{ marginTop: 10, marginRight: 10 }}>Desde:</span>
          <Calendario
            Fecha={FechaDesde}
            setFecha={(fecha) => useStoreReportes.setState({ FechaDesde: fecha })}
          />
        </div>
        <div>
          <span style={{ marginTop: 10, marginRight: 10 }}>Hasta:</span>
          <Calendario
            Fecha={FechaHasta}
            setFecha={(fecha) => useStoreReportes.setState({ FechaHasta: fecha })}
          />
        </div>
      </div>

      <div className="reportes-container">



        <div className="graficos-reportes">

          {/* Gráficos por unidad de medida */}
          {BuscandoStock ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" />
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {Object.keys(chartsByUnit).length > 0 ? (
                Object.keys(chartsByUnit).map((unidad, index) => {
                  const unitChart = chartsByUnit[unidad];
                  const unitData = ListaPorMercaderia.filter(item =>
                    (item.UnidadDescripcion || 'Sin unidad') === unidad
                  );

                  // Calcular totales para esta unidad
                  const totalPeso = unitData.reduce((acc, curr) => acc + Number(curr.Peso || 0), 0);
                  const totalUnidades = unitData.reduce((acc, curr) => acc + Number(curr.Unidades || 0), 0);

                  return (
                    <div key={`despacho-${unidad}`} className="charts-row"
                      style={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'start',
                        justifyContent: 'center',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        paddingBottom: '10px',
                        width: '100%',
                        height: '400px'
                      }}>
                      {/* <h4 style={{
                        textAlign: 'center',
                        color: '#545454',
                        marginBottom: '15px',
                        fontSize: '1.1em',
                        fontWeight: 'bold'
                      }}>
                        {unidad}
                      </h4> */}

                      <div className="fila-reportes">
                        {/* Gráfico de barras */}
                        <div className="charts-row"
                          style={{
                            display: 'flex',
                            gap: '5px',
                            alignItems: 'start',
                            justifyContent: 'center',
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            paddingBottom: '10px',
                            width: '100%',
                            height: '400px'
                          }}>
                          <Chart
                            type="bar"
                            data={unitChart.data}
                            options={unitChart.options}
                            style={{ height: "350px", padding: "5px" }}
                          />
                        </div>

                        {/* Círculos de totales  */}
                        <div className="circulos-wrapper " style={{ marginTop: 50 }}>
                          {/* <div className="circle-container">
                            <div className="circle-content">
                              <div className="circle-number">{totalUnidades.toFixed(2)}</div>
                              <div className="circle-label">Total Bultos</div>
                            </div>
                          </div> */}
                          <div className="circle-container" style={{ border: '6px solid #ffc252ff' }}>
                            <div className="circle-content">
                              <div className="circle-number" style={{ color: '#ffc252ff' }}>
                                {parseFloat(totalPeso.toFixed(2))}
                              </div>
                              <div className="circle-label">Total {unidad}</div>
                            </div>
                          </div>
                        </div>

                        {/* Gráfico de torta por clientes  */}
                        <div className="grafico-torta">
                          {clientePieChartsByUnit[unidad] && (
                            <div className="card" style={{ minHeight: '300px', padding: '10px' }}>
                              <h4 className="titulo-bloque">
                                Distribución por Cliente - {unidad}
                              </h4>
                              <Chart
                                type="pie"
                                data={clientePieChartsByUnit[unidad].peso.data}
                                options={clientePieChartsByUnit[unidad].peso.options}
                                style={{ height: "100%", padding: "15px" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                    </div>
                  );
                })
              ) : (
                <div className="card">
                  <Chart type="bar" data={chartData} options={chartOptions} style={{ height: "300px", padding: "5px" }} />
                </div>
              )}
            </div>
          )}


        </div>
      </div>
    </div>
  );
};

export default DespachoReportes;
